<template>
  <v-container>
    <h3>停止表示判定設定</h3>

    <v-form @submit.prevent ref="form" class="mt-8 mb-5">

      <v-row>
        <v-col :cols="$vuetify.display.mobile ? 12 : 4" class="d-flex align-center">
          <v-label>モジュール選択</v-label>
        </v-col>
        <v-col :cols="$vuetify.display.mobile ? 12 : 4">
          <v-select density="compact" hide-details="true"
            v-model:model-value="moduleID" :items="browsableModules"></v-select>
        </v-col>
      </v-row>

      <v-divider class="my-7"></v-divider>

      <v-row v-if="moduleID !== ''">
        <v-col :cols="$vuetify.display.mobile ? 12 : 4" class="d-flex align-center">
          <v-label>経過時間（分）</v-label>
        </v-col>
        <v-col :cols="$vuetify.display.mobile ? 12 : 4">
          <v-text-field density="compact"
            :rules="[
              v => (!!v) || '必須、数値（1 ～ 1440）',
              v => (v && Number.isInteger(Number(v)) && 1 <= Number(v) && Number(v) <= 1440) || '必須、数値（1 ～ 1440）'
            ]"
            persistent-hint hint="必須、数値（1 ～ 1440）"
            v-model="passedMinutes" :readonly="!configurableModules.includes(moduleID)"></v-text-field>
        </v-col>

        <v-col cols="12" class="my-2">
          <v-alert variant="tonal" type="success" v-model="isShowMessage" closable>変更しました</v-alert>
        </v-col>

        <v-col cols="12" class="text-end" v-if="configurableModules.includes(moduleID)">
          <v-btn :elevation="0" color="primary" v-on:click="putMissingDataCriteria" :loading="isLoading">
            変更する
          </v-btn>
        </v-col>
      </v-row>

    </v-form>
  </v-container>
</template>

<script>
import { defineComponent, onMounted, ref, watch } from 'vue';

import axios from 'axios';

import config from '@/config.js';

export default defineComponent({
  name: 'StoppedIndicationCriteriaSetting',

  setup() {

    const form = ref();

    const moduleID = ref('');

    const browsableModules = ref([
      { title: '未選択', value: '' }
    ]);

    const configurableModules = ref([]);

    const passedMinutes = ref('');

    const isShowMessage = ref(false);

    const isLoading = ref(false);

    onMounted(() => {

      fetchModuleList();

      watch(moduleID, () => {

        isShowMessage.value = false;

        if (moduleID.value === '') {
          return;
        }

        fetchMissingDataCriteria();

      });

    });

    const fetchModuleList = () => {

      axios.get(
        config.API_URL +
        `/users/me`,
        { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem("access-token") } }
      ).then((response) => {

        response.data.browsableModules.forEach((moduleID) => {
          browsableModules.value.push({
            title: moduleID,
            value: moduleID
          });
        });

        response.data.configurableModules.forEach((moduleID) => {
          configurableModules.value.push(moduleID);
        });

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });

    };

    const fetchMissingDataCriteria = () => {

      axios.get(
        config.API_URL +
        `/modules/${ moduleID.value }/missing-data-criteria`,
        { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem('access-token') } }
      ).then((response) => {

        passedMinutes.value = response.data.missingDataCriteria.intervalMinutes.toString();

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });

    };

    const putMissingDataCriteria = async () => {

      const { valid } = await form.value.validate();
      if (!valid) {
        return;
      }

      passedMinutes.value = Number(passedMinutes.value).toString();


      isLoading.value = true;
      isShowMessage.value = false;

      const reqBody = {
        intervalMinutes: Number(passedMinutes.value)
      };

      axios.put(
        config.API_URL +
        `/modules/${ moduleID.value }/missing-data-criteria`,
        reqBody,
        { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem('access-token') } }
      ).then((/* response */) => {

        isLoading.value = false;
        isShowMessage.value = true;

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });

    };

    return {
      form,

      moduleID,

      browsableModules,

      configurableModules,

      passedMinutes,

      isShowMessage,

      isLoading,

      putMissingDataCriteria
    }

  }
});
</script>
